export default __webpack_public_path__ + "static/media/modern.3cbabc1e.png";